import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SrvButton from "../../../../components/global/SrvButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faEdit, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import SrvButtonLink from "../../../../components/global/SrvButtonLink";
import CardTimetableEdit from "./CardTimetableEdit";
import axios from "axios";
import "./CardTimetable.css"
import ErrorAdd from "../../../../util/ErrorAdd";

function CardTimetable({ idTask, onlyRead }) {

    const stateTaskRtimetableList = useSelector((state) => state.taskRlist);//Список расписаний
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const [listModal, setListModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [removeModal, setRemoveModal] = useState(false);
    const [selectedModel, setSelectedModel] = useState(null);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        //Действия при открытии модального окна

        setLog(null);
        setLoading(false);
    }, []);

    function removeHundler() {
        axios.post('/api_tracker/taskR/timetableRemove', { ID_Timetable: selectedModel.ID, ID_TaskR: selectedModel.ID_TaskR })
            .then((res) => {
                if (res.data.Status === 1) {
                    setRemoveModal(false);
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function addHandler() {
        setListModal(true);
        if (stateTaskRtimetableList.listTimetable.filter(a => a.ID_TaskR === idTask).length === 0) {
            setSelectedModel(null);
            setEditModal(true);
        }
    }

    console.log('onlyRead', onlyRead)

    return (
        <>
            {stateTaskRtimetableList.listTimetable.filter(a => a.ID_TaskR === idTask).length === 0 ? (
                onlyRead === false ?
                    <div className="d-flex justify-content-center" style={{ height: '60px' }}>
                        <SrvButtonLink typeBtn="add" textBtn="Добавить расписание" onClick={() => addHandler(true)} />
                    </div>
                    :
                    <div className="form_error mb-10">Нет расписаний</div>
            )
                :
                stateSize.desktop === true ? (
                    <div className="card_widget_body">
                        <div className="card_widget_btn_edit">
                            <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setListModal(true)} />
                        </div>
                        {
                            stateTaskRtimetableList.listTimetable.filter(a => a.ID_TaskR === idTask).map((timetable) => (
                                <div key={timetable.ID}>
                                    <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{timetable.Timetable_String}</div>
                                    {timetable.Day_Complite !== null && (
                                        <div className="widget-subheading"><i>{timetable.Day_Complite} дн. для решения</i></div>
                                    )}
                                </div>
                            ))
                        }
                    </div>
                ) : (
                    <div className="card_widget_body">
                        {onlyRead === false &&
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginLeft: 'auto' }}>
                                    <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setListModal(true)} />
                                </div>
                            </div>
                        }


                        <div className="m_card_timetable_row">
                            {
                                stateTaskRtimetableList.listTimetable.filter(a => a.ID_TaskR === idTask).map((timetable) => (
                                    <div key={timetable.ID} className="m_card_timetable_row_item">
                                        <div>
                                            <div className="title"><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{timetable.Timetable_String}</div>
                                            {/*timetable.Day_Complite !== null && (
                                            <div className="subtitle"><i>{timetable.Day_Complite} дн. для решения</i></div>
                                        )*/}
                                        </div>

                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )}

            {listModal === true && (
                <Modal show={listModal} onHide={() => setListModal(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setListModal(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">Расписания</div>

                        <div className="d-flex justify-content-end mt-15">
                            <SrvButtonLink typeBtn="add" textBtn="Добавить" onClick={() => { setSelectedModel(null); setEditModal(true) }} />
                        </div>
                        <div className="mt-15">
                            {
                                stateTaskRtimetableList.listTimetable.filter(a => a.ID_TaskR === idTask).map((timetable) => (
                                    <div key={timetable.ID} className="d-flex bd-highlight row_select">
                                        <div className="p-2 flex-grow-1 bd-highlight">
                                            <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{timetable.Timetable_String}</div>
                                            {timetable.Day_Complite !== null && (
                                                <div className="widget-subheading"><i>{timetable.Day_Complite} дн. для решения</i></div>
                                            )}
                                        </div>
                                        <div className="p-2 bd-highlight">
                                            <button className="btn-square btn-hover-shine btn btn-secondary mr-5" onClick={() => { setSelectedModel(timetable); setEditModal(true) }}>
                                                <i>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </i>
                                            </button>
                                            <button className="btn-square btn-hover-shine btn btn-secondary" onClick={() => { setSelectedModel(timetable); setRemoveModal(true) }}>
                                                <i>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </i>
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            )}
            {editModal === true && (
                <CardTimetableEdit show={editModal} onHide={() => setEditModal(false)} model={selectedModel} idTask={idTask} />
            )}
            {removeModal === true && (
                <Modal show={removeModal} onHide={() => setRemoveModal(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setRemoveModal(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">Удаление расписания</div>
                        <div className="text-center mt-20">Подтвердите удаление расписания <br></br> <b>«{selectedModel.Timetable_String}»</b></div>

                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}

                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="remove" size='lg' loading={loading} onClick={() => removeHundler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}

export default CardTimetable;